import React, {useState} from 'react'
import { motion, useScroll, useTransform, useSpring} from 'framer-motion';
import hotel1 from "../assets/hotel1.jpg"
import hotel2 from "../assets/hotel2.webp"
import whatsapp from "../assets/whatsapp.png"
import { CButton } from '@coreui/react'

function TuEstancia() {
     const [isHotelFlipped, setIsHotelFlipped] = useState(false);
  const [isAirbnbFlipped, setIsAirbnbFlipped] = useState(false);
  return (
    <div>
        <div className="header-seccion">
            <h1 className="blanco bold">Alojamiento</h1>
            <p className="text-md blanco">Para disfrutar al máximo junto con nosotros,<b className="text-md blanco bold"> te recomendamos llegar a Mineral del Chico un día antes de la boda</b> y hospedarte ahí al menos dos noches: la previa a la boda y el gran día.</p>
            <p className="text-lg blanco text-cursiva" style={{marginTop:"2rem"}}>Esta es nuestra recomendación de hospedaje:</p>
          </div>

           <div className="recomendaciones-hospedaje">
                <motion.div
                        className="cont-card-recomendacion"
                        style={{ transformStyle: "preserve-3d" }}
                        initial={false}
                        animate={{ rotateY: isHotelFlipped ? 180 : 0 }}
                        transition={{ type: "spring", stiffness: 260, damping: 20 }}
                      >


                        <div className="card-recomendacion-front" style={{ backfaceVisibility: "hidden" }}>
                          <div className="cont-img-hotel">
                            <img src={hotel2} alt="" />
                            <img src={hotel1} alt="" />
                          </div>
                          <div className="cont-descripcion-hotel">
                            <h2 className='bold'>Hotel  El Paraíso</h2>
                            <p className="text-md">El lugar donde sucederá la mayor parte del evento. Enclavado en el corazón del Parque Nacional El Chico, este hotel es ideal para reencontrarte con la naturaleza. Relájate con la belleza de sus paisajes y déjate consentir en este espacio, declarado reserva natural desde 1898. </p>
                            <div className="cont-botones-hotel">
                              <button className="btn-flip-card" onClick={() => setIsHotelFlipped(!isHotelFlipped)}>Reservar</button>
                            </div>
                            
                          </div>
                        </div>
                        
                      {/* Back Side */}
                        <div 
                          className="card-recomendacion-back"
                          style={{ 
                            backfaceVisibility: "hidden", 
                            transform: "rotateY(180deg)" 
                          }}
                        >
                          <div className="cont-detalles-telefono">
                          <p className="text-md">Reservaciones directamente con el departamento de ventas del hotel.</p>
                          <div className="cont-num-hotel">
                            <img src={whatsapp} alt="" className='icono-whatsapp'/>
                             <p className="text-md">771 204 20 96</p> 
                          </div>

                          

                          </div>

                          <p className="text-lg bold">Boda Diana & Emmanuel</p>
                          
                        <div className="cont-habitaciones">
                            <div className="cont-detalles-habitacion">
                              <p className="text-md bold">Habitación doble</p>
                              <p className="text-md">Dos camas matrimoniales</p>
                              <p className="text-md">$3,360.00</p>
                            </div>
                             <div className="cont-detalles-habitacion">
                              <p className="text-md bold">Habitación sencilla</p>
                              <p className="text-md">Una cama King size</p>
                              <p className="text-md">$3,360.00</p>
                            </div>
                          </div>
                          

                          <p className="text-md">Tarifa por noche, incluye impuestos para 1 ó 2 personas.</p>
                          <p className="text-md">Persona extra $590.00 mayor de 10 años. $90.00 menores de 2 a 10 años</p>
                          <p className="text-md">Precio sujeto a cambios sin previo aviso.</p>


                          <div className="cont-botones-hotel">
                            <a href='https://drive.google.com/file/d/1dMlmAExncXwS8bF4E7QJV7JMCNLS1V8M/view?usp=sharing' target= "_blank" className="btn-flip-pago" >Datos de pago</a>
                            <button className="btn-flip-card" onClick={() => setIsHotelFlipped(!isHotelFlipped)}>Regresar</button>
                          </div>
                          
                          
                        </div>

                </motion.div>

              </div>
    </div>
  )
}

export default TuEstancia